import { navigate } from '@reach/router';
import React from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import Button from '@ui/atoms/Button';
import { DashboardCardLayout } from '@ui/atoms/DashboardCardLayout';
import HeadingText from '@ui/atoms/HeadingText';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import RoundedCard from '@ui/molecules/RoundedCard';

import { IPageProps } from '@folx-types/flow-steps';

import theme from '@theme/FolxTheme';

export interface IReactivateMembershipPageContent {
	heading: string;
	description: string;
	disclaimer?: string;
}

interface IReactivateMembershipProps extends IPageProps {
	pageContent: IReactivateMembershipPageContent;
}

const ReactivateMembershipCardLayout = styled(DashboardCardLayout)`
	max-width: 100%;
	overflow-x: hidden;
	padding: 0 ${theme.spacing.md};
	@media ${theme.responsive.breakpoints.laptop} {
		overflow-x: visible;
		padding: 0;
	}
`;

const ReactivateButton = styled(Button)`
	margin: 0 auto;
`;

const FineprintWYSIWYG = styled(WYSIWYGContent)`
	p,
	a {
		font-size: ${theme.fontSizes.body.xs};
	}
`;

const ReactivateMembership = ({ pageContent }: IReactivateMembershipProps) => {
	const { heading, description, disclaimer } = pageContent;

	return (
		<ReactivateMembershipCardLayout>
			<HeadingText>{heading}</HeadingText>
			<BasicText>{description}</BasicText>
			<ReactivateButton
				label="Reactivate my membership"
				labelSize="sm"
				onClick={() =>
					navigate(
						`/app/member/reactivate_membership/summary/${!disclaimer ? '?backTo=get_care' : ''}`
					)
				}
			/>
			{disclaimer && (
				<RoundedCard bgColor="cardBeige" headerMargin="xssm" footerMargin="xssm">
					<BasicText variant="fineprint">
						<FineprintWYSIWYG dangerouslySetInnerHTML={{ __html: disclaimer }} />
					</BasicText>
				</RoundedCard>
			)}
		</ReactivateMembershipCardLayout>
	);
};

export default ReactivateMembership;
